import type { FC } from "react";

import MobileStores from "@/src/shared/mobile-stores";
import ImageLoader from "@Components/ImageLoader";
import { getCdnImage } from "@Components/Modules/Helpers";
import type { QueryXsMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import CashbackCheck from "./icons/CashbackCheck";

import * as css from "./GoodieAdvantages.module.css";

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    storeLogo: {
        display: "inline-block",
        height: {
            default: "40px",
            [xsMax]: "35px",
        },
        marginTop: "15px",
    },
    icon: {
        height: "14px",
        width: "18px",
    },
});

export interface IGoodieAdvantages {
    advantagesList: IGoodieAdvantagesItems[];
    appAdvantageItem: IGoodieAdvantagesItems;
    telemetryMobileStore?: string;
}

export interface IGoodieAdvantagesItems {
    title: string;
    description: string;
}

const GoodieAdvantages: FC<IGoodieAdvantages> = ({
    advantagesList,
    appAdvantageItem,
    telemetryMobileStore,
}) => (
    <div className={css.goodieAdvantagesComponent}>
        <div className={css.descriptionSection}>
            <div className={css.wrap}>
                {advantagesList.map((item: IGoodieAdvantagesItems, index: number) => (
                    <div key={index} className={css.advantageItem}>
                        <CashbackCheck {...stylex.props(styles.icon)} />
                        <div className={css.advantageItemInfo}>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        <div className={css.imageSection}>
            <div className={css.appAdvantageImage}>
                <ImageLoader
                    src={getCdnImage(process.env.CB_Advantages)}
                    alt="Goodie Cashback Application Icon"
                />
            </div>
            <div className={css.appAdvantageInfo}>
                <h3>{appAdvantageItem.title}</h3>
                <p>{appAdvantageItem.description}</p>
            </div>
            <div className={css.appStoresLinks}>
                <MobileStores
                    referrer="goodie_advantages"
                    telemetryOrigin={telemetryMobileStore}
                    styleX={styles.storeLogo}
                />
            </div>
        </div>
    </div>
);

export default GoodieAdvantages;
